import get from 'lodash/get'
import isObject from 'lodash/isObject'
import fromPairs from 'lodash/fromPairs'

const parse = (queryString = null) => {
	let query = (null !== queryString ? queryString : window.location.search)
	if (!query) {
		return false
	}

	if ('?' === query.substr(0, 1)) {
		query = query.substring(1)
	}

	const params = new URLSearchParams(query)

	return fromPairs(Array.from(params.entries()))
}

const addArg = (key, value, queryString = null) => {
	let query = (null !== queryString ? queryString : window.location.search)
	query = query ? ('?' === query.substr(0, 1) ? query.substring(1) : query) : '?'

	const params = new URLSearchParams(query)
	params.set(key, value)

	return params.toString()
}

/**
 * Serialize URL query params. Handles array/object args.
 *
 * @param {Object} params The export parameters
 * @param {string} prefix Option prefix
 *
 * @returns {string} The serialized query string
 */
const serialize = (params, prefix) => {
	let query = isObject(params) ? Object.keys(params).map((key) => {
		const value  = null === params[key] || undefined === params[key] ? '' : params[key]

		if (params.constructor === Array) {
			key = `${prefix}[]`
		} else if (params.constructor === Object) {
			key = (prefix ? `${prefix}[${key}]` : key)
		}

		if (isObject(value)) {
			return serialize(value, key)
		}

		return `${key}=${encodeURIComponent(value)}`
	}) : []
	query = query.filter(k => !!k)

	return query.length ? [].concat.apply([], query).join('&') : ''
}

const getArg = (key, queryString = null) => get(parse(queryString), key)

export default {
	parse,
	add       : addArg,
	get       : getArg,
	serialize : serialize,
}
